<template>
	<div id="signaturePadMain" style="display: flex;flex-direction: column;">
		<div class="width_100 all_height_line16 text16 textcolor333"
			style="background-color: white;text-align: center;">手写签名
			<img class="back" src="@/assets/images/back.svg" style="width: 1rem;height: 1rem;" @click="back" />
		</div>
		<div class="signature_pad" ref="signaturepad">
			<canvas ref="canvas" :width="width" :height="height"></canvas>
		</div>
		<div class="signature_tool">
			<span class="all_height16 all_line_height8 text10 textcolor333 width_flex">请用正楷书写您的签名，避免字迹过于潦草导致无法律效力</span>
			<button class="all_height_line14 text12 textcolor333" style="border-radius: 5px;"
				@click="clear()">重&nbsp;&nbsp;写</button>
			<button class="all_button16 all_height_line14  text12 bmain_active" @click="save()">保&nbsp;&nbsp;存</button>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		isHarmony,
		harmonyScreenSwitch
	} from '../../../utils/nativeOtherOperate.js'
	import SignaturePad from 'signature_pad'
	export default {
		data() {
			return {
				//默认宽高
				width: 500,
				height: 200,
				//签名控件
				signature: null,
			}
		},
		methods: {
			//退出
			back() {
				this.signature.clear()
				this.$router.go(-1)
			},
			//重写
			clear() {
				this.signature.clear()
			},
			//判空
			isEmpty() {
				return this.signature.isEmpty()
			},
			//获取base64
			getDataUrl() {
				return this.signature.toDataURL()
			},
			//上传签名
			save() {
				if (!this.isEmpty()) {
					this.$store.dispatch(this.$LoadShow, true)
					this.$post('/my/api/saveSignature', {
						signature: this.getDataUrl(),
						isGenerate: false
					}, 'form').then((
						res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.$Toast('保存成功！')
							this.$router.go(-1);
						} else {
							this.$Toast(res.message || '保存失败，请重试！')
						}
					});
				} else {
					this.$Toast("请手写签名！")
				}
			}
		},
		computed: {
			resize() {
				//this.width = document.body.clientHeight + 10 //宽
				this.width = document.getElementById('signaturePadMain').clientHeight + 10 //宽
				//console.log('this.$refs.signaturepad--=' + this.$refs.signaturepad)
				this.height = document.body.clientWidth - 140 //高
				if (this.width === 10) {
					this.width = this.height * 2
				}
			}
		},
		created() {
			if(isHarmony()){
				harmonyScreenSwitch('2')
				return
			}
			//全屏设置
			if (window.plus) {
				// 隐藏顶部电池,时间等信息
				plus.navigator.setFullscreen(true);
				// 隐藏虚拟按键
				plus.navigator.hideSystemNavigation()
				plus.screen.lockOrientation('landscape-primary');
			}
			
		},
		mounted() {
			window.addEventListener('resize', this.resize);
			const canvas = this.$refs.canvas
			this.signature = new SignaturePad(canvas)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize);
			if(isHarmony()){
				harmonyScreenSwitch('1')
				return
			}
			//取消全屏
			if (window.plus) {
				// 显示顶部电池,时间等信息
				plus.navigator.setFullscreen(false);
				// 显示虚拟按键
				plus.navigator.showSystemNavigation()
				plus.screen.lockOrientation('portrait-primary');
			}
		},
		destroyed() {

		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.back {
		position: absolute;
		top: .3rem;
		left: .5rem;
	}

	.signature_pad {
		width: 100%;
		flex: 1;
		background-color: #f2f2f2;
		padding: .05rem;

		// canvas {
		// 	width: 100%;
		// 	height: 100%;
		// }

	}

	.signature_tool {
		width: 100%;
		height: 2rem;
		background-color: white;
		padding: 0.2rem .5rem;
		display: flex;

		button {
			padding: 0 .8rem;
			margin-left: 1rem;

		}
	}
</style>